import * as Yup from "yup";

export const schemaSubscriptionForm = Yup.object().shape({
  email: Yup.string()
    .email("Ongeldig e-mail")
    .required("Dit is een verplicht veld."),
});
